
import React from 'react';
import { VideoCarouselItem } from './VideoCarouselItem';
import { YouTubeVideo } from '@/services/youtubeVideoService';

interface VideoCarouselProps {
  videos: YouTubeVideo[];
  onVideoDeleted: () => Promise<void>;
}

export const VideoCarousel: React.FC<VideoCarouselProps> = ({
  videos,
  onVideoDeleted
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {videos.map((video) => (
        <VideoCarouselItem
          key={video.id}
          video={video}
          onVideoDeleted={onVideoDeleted}
        />
      ))}
    </div>
  );
};
